<div class="list-item-container ui-g ui-g-12 no-padding"
	*ngIf="context.data?.entityInstance?.id === null">
	<span class="panel-sub-title">
		No Data
	</span>
</div>
<div class="list-item-container ui-g ui-g-12 no-padding"
	*ngIf="context.data?.entityInstance?.id != null">
	<ul>
		<ng-template
			[ngIf]="(data?.length || 0) > 0"
			ngFor
			let-item
			[ngForOf]="data">
			<li *ngIf="item.type != null"
				class="section-container">
				<span class="data-value">
					<p-divider align="left">
						<div>
							<span *ngIf="item.iconClass != null"
								class="fa {{item.iconClass}}">
							</span>
							<span class="panel-sub-title">
								{{getDisplaySubTitle(item.type)}}
							</span>
						</div>
					</p-divider>

					<span class="data-value">
						<ng-template [ngIf]="item.displayProperties != null"
							[ngIfElse]="Default"
							ngFor
							let-property
							[ngForOf]="item.displayProperties">
								<span *ngIf="property.label != null"
									class="property-asset">
									<strong>
										{{property.label}}
									</strong>
									{{property.value}}
									<br>
								</span>
						</ng-template>

						<ng-template #Default>
							<ng-template [ngIf]="item.characteristics.addresses != null"
								[ngIfElse]="FallBack">
								<strong>Address:</strong>
								<span *ngIf="item.characteristics.addresses[0] != null">
									<span *ngIf="item.characteristics.addresses[0].address != null
										&& item.characteristics.addresses[0].address != ''">
										{{item.characteristics.addresses[0].address}},
									</span>
									<span *ngIf="item.characteristics.addresses[0].city != null
										&& item.characteristics.addresses[0].city != ''">
										{{item.characteristics.addresses[0].city}},
									</span>
									{{item.characteristics.addresses[0].state}}
									{{item.characteristics.addresses[0].postalCode}}
								</span>
							</ng-template>

							<ng-template #FallBack>
								<strong>Description:</strong>
								{{item.characteristics.description ?? item.characteristics.displayDescription}}
							</ng-template>
						</ng-template>
					</span>

				</span>
				<br />
			</li>
		</ng-template>
	</ul>
</div>